import Box from '@mui/material/Box';
import type { ReactElement } from 'react';

import { tokens } from '../../../design';
import { initials } from '../../../utils/initials';

/**
 * A company's logo (signed URL from the API) or its initials on the brand
 * tile, after the mockup's `.org-logo`. `size` in px; `dimmed` for a
 * terminated company in the list.
 */
export const CompanyLogo = ({
  name,
  logoUrl,
  size = 30,
  dimmed = false,
}: {
  name: string;
  logoUrl: string | null;
  size?: number;
  dimmed?: boolean;
}): ReactElement => (
  <Box
    sx={{
      width: size,
      height: size,
      flexShrink: 0,
      borderRadius: `${Math.round(size / 4)}px`,
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: tokens.brand.primary,
      color: tokens.text.onBrand,
      fontSize: Math.round(size * 0.37),
      fontWeight: 800,
      opacity: dimmed ? 0.5 : 1,
    }}
  >
    {logoUrl ? (
      <Box
        component="img"
        src={logoUrl}
        alt=""
        sx={{ width: '100%', height: '100%', objectFit: 'cover', bgcolor: tokens.surface.base }}
      />
    ) : (
      initials(name)
    )}
  </Box>
);
